import StayStudyPage from "../components/StayStudyPage";

export default function Stay5() {
  return (
    <StayStudyPage
      className="Class 5"
      heroTitle="Class 5 Stay & Study Program"
      heroDescription="A nurturing residential learning program designed to strengthen fundamentals, discipline, and confidence during a key transition stage."

      section1={{
        title: "📘 Strong Academic Foundation",
        description:
          "Class 5 bridges basic learning and structured academics. Our program ensures clear understanding and steady progress.",
        points: [
          "Clear understanding of core concepts",
          "Strong focus on English, Mathematics, Science & Social Studies",
          "Step-by-step explanation of lessons",
          "Regular revision & practice worksheets",
          "Guided learning with individual attention"
        ]
      }}

      section2={{
        title: "🗓️ Disciplined Daily Routine",
        description:
          "A structured daily routine helps students develop consistency, focus, and responsibility.",
        points: [
          "Fixed supervised study hours",
          "Dedicated time for homework & revision",
          "Balanced study and rest schedule",
          "Early development of self-discipline",
          "Safe and supportive residential environment"
        ]
      }}

      whyUs={{
        title: "⭐ Why Choose ACCESS Stay & Study for Class 5?",
        description:
          "We create a caring residential environment that balances academics, discipline, and personal development.",
        points: [
          "Experienced and caring faculty",
          "24/7 supervised residential campus",
          "Daily monitored study sessions",
          "Regular assessments & feedback",
          "Individual student attention",
          "Nutritious meals & safe hostel facilities",
          "Strong focus on discipline and confidence"
        ]
      }}

      images={{
        section1: "/images/class5-2.jpg",
        section2: "/images/class5-1.jpg",
        whyUs: "/images/Hostel2.jpeg"
      }}

      fee="75,000"
      whatsappText="Hello ACCESS Team, I would like to enquire about the Class 5 Stay & Study Program."
    />
  );
}
